// Import the functions you need from the SDKs you need
// import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional

export const firebaseConfig = {
  apiKey: "AIzaSyCGO-KMM4Jopls-GruGCx91EaQ50mCIeT8",
  authDomain: "netflix-4ab25.firebaseapp.com",
  projectId: "netflix-4ab25",
  storageBucket: "netflix-4ab25.firebasestorage.app",
  messagingSenderId: "769393383958",
  appId: "1:769393383958:web:724a9ec931bff412a23337",
  measurementId: "G-4NVDCEF4WG"
};

// Initialize Firebase
// const app = initializeApp(firebaseConfig);